import React, { createContext, useContext } from "react";

export type VideoChatContextType = {
    isMyCameraOn: boolean;
    setIsMyCameraOn: (on: boolean) => void;
    selectedCameraDevice: MediaDeviceInfo | null;
    setSelectedCameraDevice: (device: MediaDeviceInfo) => void;

    isMyMicOn: boolean;
    setIsMyMicOn: (on: boolean) => void;
    selectedMicDevice: MediaDeviceInfo | null;
    setSelectedMicDevice: (device: MediaDeviceInfo) => void;

    isMyScreenShared: boolean;
    setIsMyScreenShared: (shared: boolean) => void;
};

export const VideoChatContext: React.Context<VideoChatContextType> = createContext<VideoChatContextType>({
    isMyCameraOn: false,
    setIsMyCameraOn: () => {},
    selectedCameraDevice: null,
    setSelectedCameraDevice: () => {},

    isMyMicOn: false,
    setIsMyMicOn: () => {},
    selectedMicDevice: null,
    setSelectedMicDevice: () => {},

    isMyScreenShared: false,
    setIsMyScreenShared: () => {},
});

export const useVideoChatContext = () => useContext(VideoChatContext);

export default VideoChatContext;
